import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { NavLink } from "react-router-dom";
import AdminCalendar from "../../components/AdminCalendar";
import { fetch } from '../../store/shownDataSlice';
import { fetchArrangementExceptions } from '../../store/knownArrangementsSlice';



function Schedule({}) {
    const dispatch = useDispatch();
    const [ showArrangements, setShowArrangements ] = useState(true);
    const [ showJobs, setShowJobs ] = useState(true);

    const upcomingJobs = useSelector((state) => state.shownData.upcomingJobs);
    const confirmedQueries = useSelector((state) => state.shownData.confirmedQueries);
    const arrangements = useSelector((state) => state.shownData.arrangements);
    const arrangementExceptions = useSelector((state) => state.knownArrangements.exceptionsList);

    function refresh() {
        dispatch(fetch.upcomingJobs());
        dispatch(fetch.confirmedQueries());
        dispatch(fetch.arrangements());
        dispatch(fetchArrangementExceptions());
    }

    useEffect(() => {
        refresh();
    }, []);

    const jobs = [ ...upcomingJobs, ...confirmedQueries ];

    return (
        <div className="column g32 p32">
            <div className="column g16">
                <h2>Valikud</h2>
                <div className="line g32">
                    <button onClick={() => refresh()}>Värskenda</button>
                    <div className="row center-cross g8">
                        <input type="checkbox" name="show_arrangements" id="show_arrangements" checked={showArrangements} onChange={(e) => setShowArrangements(e.target.checked)} />
                        <label htmlFor="show_arrangements">Kuva regulaarveod</label>
                    </div>
                    <div className="row center-cross g8">
                        <input type="checkbox" name="show_jobs" id="show_jobs" checked={showJobs} onChange={(e) => setShowJobs(e.target.checked)} />
                        <label htmlFor="show_jobs">Kuva üksikreisid</label>
                    </div>
                </div>
            </div>
            <AdminCalendar jobs={jobs} arrangements={arrangements} arrangementExceptions={arrangementExceptions} showArrangements={showArrangements} showJobs={showJobs} />
            <div className="row">
                <div className="column g16" style={{ alignItems: 'flex-start' }}>
                    <h2>Lisavalikud</h2>
                    <NavLink to="/platform/arrangements">Regulaarveod</NavLink>
                </div>
            </div>
        </div>
    );
}

export default Schedule;